import { CreateMenuItem, DeleteMenuItem, EmbedMenuItem, ExportMenuItem, ForkMenuItem, LikeMenuItem, ShareIdeaMenuItem } from "components/actions/header-menu-items";
import { SandboxesButton, SandboxSettingsButton, ThemeChangerButton, UserAvatarButton } from "components/elements/buttons";
import { useCallback } from "react";
import { useAppSelector } from "store";
import { Header } from "@itwin/itwinui-react";
import styles from "./MainHeader.module.css";
import { SandboxTitle } from "./SandboxTitle";
import { SamplesButton } from "components/elements/buttons/samples-button/SamplesButton";
import { selectCurrentUser } from "store/features";

export const MainHeader = () => {
  const sandbox = useAppSelector((state) => state.activeSandbox.metadata);
  const actionItems = useAppSelector((state) => state.header.actionItems);
  const user = useAppSelector(selectCurrentUser);

  const menuItemsBuilder = useCallback((close: () => void) => {
    const items: JSX.Element[] = [];

    for (const actionName of actionItems ?? []) {
      if (actionName === "create" && user && user.isBentleyUser)
        items.push(<CreateMenuItem key="sandbox-create" close={close} />)

      if (actionName === "delete" && sandbox && user && user.isBentleyUser)
        items.push(<DeleteMenuItem key="sandbox-delete" close={close} />)

      if (actionName === "fork" && sandbox && user && user.isBentleyUser)
        items.push(<ForkMenuItem key="sandbox-fork" close={close} />)

      if (actionName === "like" && sandbox)
        items.push(<LikeMenuItem key="sandbox-like" close={close} />)

      if (actionName === "embed" && sandbox)
        items.push(<EmbedMenuItem key="sandbox-embed" close={close} />)

      if (actionName === "shareIdea")
        items.push(<ShareIdeaMenuItem key="sandbox-share-idea" close={close} />)

      if (actionName === "export" && sandbox)
        items.push(<ExportMenuItem key="sandbox-export" close={close} />)
    }
    return items;
  }, [sandbox, actionItems]);

  return (
    <Header
      appLogo={null}
      isSlim={true}
      className={styles.removeHeaderLogo}
      breadcrumbs={[
        <SandboxesButton key="my-sandboxes" />,
        process.env.NODE_ENV === "development" ? <SamplesButton key="samples" /> : null
      ]}
      actions={[
        <SandboxSettingsButton key="sandbox-settings" />,
        <ThemeChangerButton key="theme-changer" />,
        <UserAvatarButton key="user-avatar" />
      ]}
      menuItems={menuItemsBuilder}
      data-testid="atp-main-header"
    >
      {sandbox && <SandboxTitle />}
    </Header >
  )
}

